<template>
  <div class="ctrl-palette">
    <div class="palette-search">
      <i class="fas fa-search"></i>
      <input v-model="searchText" placeholder="搜索控件..." class="search-input" />
    </div>
    <div class="palette-body">
      <template v-for="(group, gKey) in groupedControls" :key="gKey">
        <div class="group-header" @click="toggleGroup(gKey)">
          <i class="fas" :class="collapsed[gKey] ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
          <span>{{ groupLabels[gKey] }}</span>
          <span class="group-count">{{ group.length }}</span>
        </div>
        <div v-show="!collapsed[gKey]" class="group-items">
          <div
            v-for="c in group"
            :key="c.type"
            class="ctrl-item"
            draggable="true"
            @dragstart="$emit('dragStart', c.type)"
            @dragend="$emit('dragEnd')"
            @click="$emit('addControl', c.type)"
            :title="c.name"
          >
            <i class="ctrl-icon fas" :class="c.icon"></i>
            <span class="ctrl-name">{{ c.name }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive } from 'vue'
import { controlRegistry } from './composables/useFormState.js'

defineEmits(['dragStart', 'dragEnd', 'addControl'])
const searchText = ref('')
const collapsed = reactive({ base: false, advance: false, layout: false })
const groupLabels = { base: '基础控件', advance: '高级控件', layout: '布局控件' }

function toggleGroup(key) { collapsed[key] = !collapsed[key] }

const groupedControls = computed(() => {
  const groups = { base: [], advance: [], layout: [] }
  Object.entries(controlRegistry).forEach(([type, meta]) => {
    if (!searchText.value || meta.name.includes(searchText.value) || type.toLowerCase().includes(searchText.value.toLowerCase())) {
      groups[meta.category].push({ type, ...meta })
    }
  })
  return groups
})
</script>

<style scoped>
.ctrl-palette { width: 220px; background: #fff; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column; height: 100%; flex-shrink: 0; }
.palette-search { padding: 10px; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; gap: 6px; }
.palette-search i { color: #9ca3af; font-size: 13px; }
.search-input { border: 1px solid #e5e7eb; border-radius: 4px; padding: 6px 8px; font-size: 12px; width: 100%; outline: none; }
.search-input:focus { border-color: #10b981; }
.palette-body { flex: 1; overflow-y: auto; }
.group-header { display: flex; align-items: center; gap: 6px; padding: 8px 12px; background: #f9fafb; font-size: 12px; font-weight: 600; color: #374151; cursor: pointer; border-bottom: 1px solid #f3f4f6; user-select: none; }
.group-header:hover { background: #f0fdf4; }
.group-header i { font-size: 11px; width: 12px; color: #10b981; }
.group-count { margin-left: auto; color: #9ca3af; font-weight: 400; font-size: 11px; }
.group-items { padding: 4px; display: grid; grid-template-columns: 1fr 1fr; gap: 2px; }
.ctrl-item { display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 8px 4px; border-radius: 6px; cursor: grab; transition: all 0.15s; border: 1px solid transparent; user-select: none; }
.ctrl-item:hover { background: #ecfdf5; border-color: #a7f3d0; }
.ctrl-item:active { cursor: grabbing; }
.ctrl-icon { font-size: 18px; color: #10b981; }
.ctrl-name { font-size: 11px; color: #6b7280; text-align: center; }
</style>
